import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';

export const Checkboxes = styled.div`
  margin-top: 40px;

  .custom-control {
    margin-bottom: 32px;
  }
`;

export const CandidateInfo = styled.p`
  margin: 32px 0 24px 0px;
  font-size: ${fontSize(14)};
  line-height: 1.71;
  letter-spacing: -0.21px;
  text-align: left;
  color: #00202d;

  span {
    font-weight: bold;
  }
`;

export const Switcher = styled.div`
  display: flex;
  margin-bottom: 70px;

  .custom-control {
    + .custom-control {
      margin-left: 40px;
    }
  }
`;

export const FieldsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: ${fontSize(25)};
    color: ${({ theme }) => theme.colors.link.primary};
    margin: 10px 0;
  }

  h2 {
    margin: 10px 0;
    font-size: ${fontSize(16)};
  }
`;

export const SuccessWrapper = styled.div`
  text-align: center;
  height: fit-content;
  align-self: center;
  position: relative;
  margin-top: -130px;

  h2 {
    font-weight: 700;
    font-size: ${fontSize(18)};
    margin: 32px 0;
  }
`;
